import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres6eu/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres6eu/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    let sendParams = {}
    if (typeof searchParams !== 'undefined') {
      sendParams = {
        p_dtest: (typeof searchParams.dteapprst !== 'undefined' ? searchParams.dteapprst : ''),
        p_dteen: (typeof searchParams.dteappren !== 'undefined' ? searchParams.dteappren : ''),
        p_staappr: (typeof searchParams.staappr !== 'undefined' ? searchParams.staappr : 'P'),
        p_codempid: (typeof searchParams.codempid !== 'undefined' ? searchParams.codempid : '')
      }
    }
    return instance().get(endpoint + '/hres6eu/index', { params: sendParams })
  },
  getDetail (searchParams) {
    if (isMock) return generator(mocker.detail())
    const params = searchParams.p_codempid + '/' + searchParams.p_dtereq.replace(/\//g, '') + '/' + searchParams.p_numseq
    return instance().get(endpoint + '/hres6eu/detail/' + params)
  },
  postSendApprove (sendParams) {
    if (isMock) return generator(mocker.sendApprove())
    return instance().post(endpoint + '/hres6eu/sendApprove', sendParams)
  },
  getDropdowns () {
    if (isMock) return generator(mocker.detail())
    return instance().get(endpoint + '/hres6eu/dropdowns')
  },
  getWorkTable () {
    if (isMock) return generator(mocker.detail())
    return instance().get(endpoint + '/hres6eu/workTable')
  }
}



// WEBPACK FOOTER //
// ./src/api/hres6eu/index.js